import { Lineup, MatchData, OddsData } from "@/interfaces/liveGamesType";
import { api } from "@/services/api";
import { useEffect, useState } from "react";
import { format } from "date-fns";

interface ResultScore {
  homeTeamLogo: string;
  awayTeamLogo: string;
  awayTeamScore: string;
  homeTeamScore: string;
  matchDate: string;
  awayTeamName: string;
  homeTeamName: string;
  draw: boolean;
  awayTeamIsWinner: boolean;
  homeTeamIsWinner: boolean;
}

const getMatchIframe = async (match: MatchData) => {
  try {
    // const awayName = match.match_awayteam_name
    //   .replaceAll(" ", "-")
    //   .toLowerCase();
    // const homeName = match.match_hometeam_name
    //   .replaceAll(" ", "-")
    //   .toLowerCase();
    // const slug = `${homeName}-${awayName}`;
    // const slugRevert = `${awayName}-${homeName}`;

    // const response = await api.get("/football/getAttackMomentum", {
    //   params: {
    //     slug,
    //     slugRevert,
    //   },
    // });
    // const data = response.data.data;

    // return data.id;
    return 0;
  } catch (e) {
    return 0;
  }
};

const getMatchStats = async (matchId: string) => {
  try {
    const response = await api.get("/football/matchStats", {
      params: {
        matchId: matchId,
      },
    });
    const data = response.data.data as OddsData;

    return {
      homeTeamWin: parseFloat(data.homeTeamWin),
      awayTeamWin: parseFloat(data.awayTeamWin),
      draw: parseFloat(data.draw),
      doubleChanceHomeTeamWinOrDraw: parseFloat(
        data.doubleChanceHomeTeamWinOrDraw
      ),
      doubleChanceAwayTeamWinOrDraw: parseFloat(
        data.doubleChanceAwayTeamWinOrDraw
      ),
      homeTeamOrAwayTeamToWin: parseFloat(data.homeTeamOrAwayTeamToWin),
      over2point5GoalsPerMatch: parseFloat(data.over2point5GoalsPerMatch),
      under2point5GoalsPerMatch: parseFloat(data.under1point5GoalsPerMatch),
      over1point5GoalsPerMatch: parseFloat(data.over1point5GoalsPerMatch),
      under1point5GoalsPerMatch: parseFloat(data.under1point5GoalsPerMatch),
      over3point5GoalsPerMatch: parseFloat(data.over3point5GoalsPerMatch),
      under3point5GoalsPerMatch: parseFloat(data.under3point5GoalsPerMatch),
      bothTeamToScore: parseFloat(data.bothTeamToScore),
      onlyOneTeamToScore: parseFloat(data.onlyOneTeamToScore),
    };
  } catch (e) {
    return {
      homeTeamWin: 0,
      awayTeamWin: 0,
      draw: 0,
      doubleChanceHomeTeamWinOrDraw: 0,
      doubleChanceAwayTeamWinOrDraw: 0,
      homeTeamOrAwayTeamToWin: 0,
      over2point5GoalsPerMatch: 0,
      under2point5GoalsPerMatch: 0,
      over1point5GoalsPerMatch: 0,
      under1point5GoalsPerMatch: 0,
      over3point5GoalsPerMatch: 0,
      under3point5GoalsPerMatch: 0,
      bothTeamToScore: 0,
      onlyOneTeamToScore: 0,
    };
  }
};

const getLineUps = (
  system: string,
  startLineup: Lineup["starting_lineups"],
  positions: string[]
) => {
  const systemWithGoalkeeper = `1-${system}`;
  const lineupCopy = [...startLineup];

  const formation = systemWithGoalkeeper.split("-").map((numPlayers, index) => {
    const numberPlayers = parseInt(numPlayers);
    const percent = { percent: positions[index] };
    const slicedPlayers = lineupCopy.slice(0, numberPlayers);
    lineupCopy.splice(0, numberPlayers);

    return { ...percent, players: slicedPlayers };
  });

  return formation;
};

const countResults = (teamId: string, results: MatchData[]) => {
  return results.reduce((acc: string[], match) => {
    const teamScore =
      parseInt(match.match_hometeam_id) === parseInt(teamId)
        ? match.match_hometeam_score
        : match.match_awayteam_score;
    const opponentScore =
      parseInt(match.match_awayteam_id) === parseInt(teamId)
        ? match.match_hometeam_score
        : match.match_awayteam_score;

    if (teamScore > opponentScore) {
      acc.push("V");
    } else if (teamScore < opponentScore) {
      acc.push("D");
    } else {
      acc.push("E");
    }

    return acc;
  }, []);
};

const countResultsScores = (results: MatchData[]): ResultScore[] => {
  return results?.map((match) => {
    const awayTeamLogo = match.team_away_badge
      ? match.team_away_badge
      : "Logo não encontrada";
    const homeTeamLogo = match.team_home_badge
      ? match.team_home_badge
      : "Logo não encontrada";
    const awayTeamScore = match.match_awayteam_score;
    const homeTeamScore = match.match_hometeam_score;
    const matchDate = match.match_date;
    const awayTeamName = match.match_awayteam_name;
    const homeTeamName = match.match_hometeam_name;

    return {
      draw: parseInt(homeTeamScore) === parseInt(awayTeamScore),
      awayTeamIsWinner: parseInt(awayTeamScore) > parseInt(homeTeamScore),
      awayTeamName: awayTeamName,
      awayTeamScore: awayTeamScore,
      homeTeamIsWinner: parseInt(homeTeamScore) > parseInt(awayTeamScore),
      homeTeamName: homeTeamName,
      homeTeamScore: homeTeamScore,
      homeTeamLogo,
      awayTeamLogo,
      matchDate: format(new Date(matchDate), "dd/MM/yyyy"),
    };
  });
};

export default function useGameData() {
  return {
    getMatchStats,
    getMatchIframe,
    getLineUps,
    countResults,
    countResultsScores,
  };
}
